import {clickEvent, customEvent} from "../../../webpack/modules/events";
import {ga4TrackSimpleEvent} from "../../../webpack/modules/analytics";

customEvent('show.bs.modal', '#ar-modal', false, function() {
    checkARCompatibility();
    ga4TrackSimpleEvent({
        "event": 'augmented_reality',
        "method": 'open_popup'
    });
});

customEvent('hide.bs.modal', '#ar-modal', false, function() {
    ga4TrackSimpleEvent({
        "event": 'augmented_reality',
        "method": 'close_popup'
    });
});

clickEvent('#model-viewer', false, function() {
    ga4TrackSimpleEvent({
        "event": 'augmented_reality',
        "method": 'open_camera'
    });
});

customEvent('ar-status', '#model-viewer', false, function(element, event) {
    if (event.detail.status === 'failed') {
        document.querySelector('#model-viewer').classList.add('d-none');
        document.querySelector('#ar-text').classList.add('d-none');
        document.querySelector("#ar-error").classList.remove('d-none');
        ga4TrackSimpleEvent({
            "event": 'augmented_reality',
            "method": 'not_available'
        });
    }
});


function checkARCompatibility()
{
    let modelViewer = document.querySelector('#model-viewer');
    let text = document.querySelector('#ar-text');
    let error = document.querySelector('#ar-error');
    if (!modelViewer.canActivateAR) {
        modelViewer.classList.add('d-none');
        text.classList.add('d-none');
        error.classList.remove('d-none');
        ga4TrackSimpleEvent({
            "event": 'augmented_reality',
            "method": 'not_available'
        });
    }
}